<!-- src/views/Login/LoginView.html -->
<div class="login-wrapper">

  <div class="login-card">
    <div class="flex justify-center mb-6">
      <img 
        :src="logoUrl" 
        alt="Luna Logo" 
        class="object-contain lunalogo"
      />
    </div>

    <p>Accedi per gestire le tue prenotazioni</p>

    <form @submit.prevent="handleLogin">
      <div class="input-group">
        <label>Username</label>
        <input 
          v-model="username" 
          type="text" 
          placeholder="Il tuo username" 
          required
        />
      </div>

      <div class="input-group">
        <label>Password</label>
        <input 
          v-model="password" 
          type="password" 
          placeholder="••••••••" 
          required
        />
      </div>

      <button type="submit" :disabled="loading">
        {{ loading ? 'Connessione...' : 'Entra' }}
      </button>

      <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
    </form>
  </div>
</div>
  